<template>
    <div class="DashboardLifeskillsFavoritesView">
        <div class="scrollContainer">
            <MemolifeLogo class="--global-clickable" @click.native="$router.push({ name: 'DashboardHomeView' })" />

            <div class="title">
                {{ $t('title') }}
            </div>

            <div class="lifeskills">
                <div
                    v-for="lifeskill of lifeskills"
                    :key="lifeskill._id"
                    class="Item --global-clickable"
                    :class="{ 'is-selected': lifeskill.follow }"
                >
                    <DashboardLifeskillItem
                        class="LifeskillItem"
                        :lifeskill-id="lifeskill.number"
                        custom-click-handling
                        @click.native="toggle(lifeskill.number)"
                    />
                    <div class="Item__checkmark">
                        <svgicon class="svg-icon" icon="checkmark" />
                    </div>
                </div>
                <div class="Item Item--dummy" />
                <div class="Item Item--dummy" />
            </div>
        </div>

        <Footer
            class="footer"
            :button-label="$t('nextButton')"
            hide-pie
            :selections-count="numberOfSelections"
            @click="gotoNext()"
        />
    </div>
</template>

<translations>
  title: 'Velg fremtidsferdighetene som interesserer deg mest'
  subtitle: 'Choose your favorites from the 10 essentials'
  subtitle_no: 'Velg favorittene dine fra de 10 anbefalte'

  nextButton: 'Next'
  nextButton_no: 'Neste'
</translations>

<script>
import Footer from './DashboardLifeskillsVoteView/Footer';
import MemolifeLogo from '@/components/MemolifeLogo';
import DashboardLifeskillItem from '@/modules/dashboard/components/DashboardLifeskillItem';

export default {
    components: { DashboardLifeskillItem, Footer, MemolifeLogo },
    computed: {
        numberOfSelections() {
            return this.lifeskills.filter(lifeskill => lifeskill.follow).length;
        },
        lifeskills() {
            return this.$store.state.moduleApp.availableFavorateLifeskillIds.map(lifeskillId => {
                return this.$store.state.moduleApp.lifeskills[lifeskillId];
            });
        }
    },
    methods: {
        toggle(lifeskillId) {
            this.$store.dispatch('moduleApp/toggleLifeskillFollow', { lifeskillId });

            this._computedWatchers.numberOfSelections.run();
            this.$forceUpdate();
        },
        gotoNext() {
            if (this.numberOfSelections === 0) {
                return;
            }
            this.$store.dispatch('moduleApp/markFavoriteLifeskillsSelected');

            this.$router.push({
                path: '/vote'
            });
        }
    }
};
</script>

<style lang="scss" scoped>
$selectionColor: #5081ff;

.DashboardLifeskillsFavoritesView {
    background: $dashboard-background;
    display: flex;
    flex-direction: column;
}

.scrollContainer {
    overflow-y: auto;
    padding-top: 2em;
    padding-left: 2em;
    padding-right: 2em;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.MemolifeLogo {
    margin-bottom: 2em;
}

.title {
    color: rgba(white, 0.9);
    font-size: 200%;
    text-align: center;
}

.lifeskills {
    display: flex;
    flex-wrap: wrap;
    margin-top: 4em;
    width: 100%;
}

.LifeskillItem {
    height: (240em / 15);
    // /deep/ .label {
    //   white-space: normal;
    // }
}

.Item {
    position: relative;
    // width: 12em;
    width: (168em / 15);
    // height: (255em / 15);

    flex-shrink: 0;
    margin: 0 1em;
    margin-bottom: 2em;

    &.is-selected {
        .Item__checkmark {
            display: flex;
        }
    }
}
.Item__checkmark {
    display: none;
    position: absolute;
    $size: 1.7em;
    width: $size;
    height: $size;
    top: -$size / 2;
    right: -$size / 2;
    background-color: $selectionColor;
    border-radius: 50%;

    justify-content: center;
    align-items: center;

    .svg-icon {
        fill: white;
        $size: 40%;
        width: $size;
        height: $size;
    }
}
.Item--dummy {
    height: 0;
    margin-top: 0;
    margin-bottom: 0;
    border: none;
}

.nextButton:not(.is-enabled) {
    opacity: 0.2;
    cursor: default;
}

// -----------------------------------------------
//
// -----------------------------------------------

@include media('<tablet') {
    .title {
        font-size: 140%;
    }
}

@include media('>=480px') {
    .lifeskills {
        justify-content: center;
        max-width: 70em;
    }
}

// -----------------------------------------------
// 2 column layout with scaling
// -----------------------------------------------

@include media('<480px') {
    $gap: 2em;
    $item-width: 12em;

    .scrollContainer {
        padding-left: 1.5em;
        padding-right: 1.5em;
    }

    .lifeskills {
        width: 100%;
        max-width: $item-width * 2 + $gap;
        justify-content: space-between;
    }

    .Item {
        // width: calc(50% - #{$gap / 2});
        margin-left: 0;
        margin-right: 0;
    }
}
</style>
